import { API_PARAM } from "./apiParam";
const { url, projectId } = API_PARAM;
export const API_QUERY = {
    formulary: {
        coverage: `${url}/Formulary/v1/Coverage?`,
        derivedField: `${url}/Formulary/v1/DerivedField?`,
        geographic: {
            cbsas: `${url}/Formulary/v1/Geographic/CBSAs?ZipCode=`,
            zips: `${url}/Formulary/v1/Geographic/Zips`
        },
        notes: {
            structuredPA: `${url}/Formulary/v1/Notes/StructuredNotesPA?`,
            structuredST: `${url}/Formulary/v1/Notes/StructuredNotesST?`
        },
        parents: `${url}/Formulary/v1/Parents?Name=`,
        plans: `${url}/Formulary/v1/Plans?`,
        products: `${url}/Formulary/v1/Products?Name=`,
        standardCriteria: `${url}/Formulary/v1/StandardCriteria?`,
        unifiedTiers: `${url}/Formulary/v1/Coverage/UnifiedTiers`
    },
    formTrak: {
        coverage: `${url}/FormTrak/v1/Projects/${projectId}/Products/` /** {ProductId}/PlanCoverages* */,
        products: `${url}/FormTrak/v1/Projects/${projectId}/Products`
    },
    token: `${url}/Token`
};
